import React from "react";

function About() {
    return (
        <div
        ><h1 className="text-2xl text-center font-bold py-6 pb-2">ჩვენ შესახებ</h1>
            <div className="mx-auto max-w-4xl">
                <p className="py-1"> ჩვენ გთავაზობთ სერვისს, რომელიც გამარტივებულად და სანდოდ ეხმარება ტურისტულ
                    კომპანიებს და ბუღალტრებს დოკუმენტაციის მოწესრიგებაში. ჩვენი პროგრამული უზრუნველყოფა საშუალებას გაძლევთ
                    მიიღოთ ავტომატურად გენერირებული ვაუჩერები და ინვოისები,
                    რომლებიც სრულად შეესაბამება საქართველოს კანონმდებლობას და შემოსავლების სამსახურის მოთხოვნებს.</p>
                <p className="py-1"> ჩვენი მიზანია, დავიცვათ თქვენი ბიზნესი ფინანსური და ადმინისტრაციული გამოწვევებისგან,
                    დაგეხმაროთ დროისა და რესურსების დაზოგვაში და უზრუნველვყოთ თქვენი დოკუმენტაცია გამჭვირვალე და მოწესრიგებული.</p>
                <p className="py-1"> ჩვენს გუნდს აქვს დიდი გამოცდილება დოკუმენტაციის ორგანიზებასა და ტექნოლოგიურ გადაწყვეტებში,
                    რაც უზრუნველყოფს თქვენს კომპანიას მაქსიმალურ სანდოობას და სრულყოფილ დაცვას. </p>
                <p className="py-1">  &quot;დაცულობისთვის შექმნილი&quot; - ეს ჩვენი მიდგომაა და ვამაყობთ იმით, რომ თქვენს გვერდით
                    ვართ ბიზნესის წარმატებისთვის. </p>
                <p className="pt-1"> კითხვების შემთხვევაში დაგვიკავშირდით: </p>
                <p> საკონტაქტო ტელეფონი:+995 577 21 08 60  </p>
                <p>  ელ-ფოსტა: offers.accservice@gmail.com </p>
            </div>
        </div>
    );
}

export default About;